<template>
  <div class="question-bank">
    <!-- 轮播图 -->
    <div class="swiper">
      <Swiper boxHeight='120px' />
    </div>

    <div class="nav-bar-box">
      <div class="nav-bar">
        <el-radio-group class="nav-bar-list" v-model="navBarRoute">
          <el-radio class="nav-bar-item" label="/question-bank/question-bank-con">题库</el-radio>
        </el-radio-group>
        <div>
        </div>
      </div>
    </div>

    <!-- 显示子路由 -->
    <router-view />

  </div>
</template>

<script>
//导入题库显示JS
import("@/assets/js/questionBank/MathJax?config=TeX-AMS-MML_HTMLorMML");
import("@/assets/js/questionBank/MLCore-2016.08.15.min.js");
// 轮播图
import Swiper from "@/components/content/Swiper";

export default {
  name: "QuestionBankCenter",
  components: {
    Swiper
  },
  data() {
    return {
      //当前路由路径
      navBarRoute: this.$route.path
    };
  }
};
</script>

<style lang="less" scoped>
.question-bank {
  //激活时和悬浮时字体颜色
  @acitveColor: #24ba58;
  //字体基础颜色
  @fontColor: #333;

  .nav-bar-box {
    box-shadow: 0 0 5px 1px #ccc;
    background-color: #fff;
    height: 40px;
    display: flex;
    justify-content: center;

    .nav-bar {
      min-width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-weight: 400;
      color: @fontColor;

      .nav-bar-list {
        /deep/.el-radio__input {
          display: none;
        }

        /deep/.el-radio__label {
          margin-left: 20px;
          font-weight: 400;
          padding-left: 0;
          color: @fontColor;
        }

        /deep/.el-radio__label:hover {
          color: @acitveColor;
        }

        /deep/.el-radio__input.is-checked + .el-radio__label {
          color: @acitveColor;
        }
      }
    }
  }
}
</style>